/* eslint-disable */
import React from 'react';
import 'contents/assets/scss/page/training.scss';

const VideoEvaluationRegister = () => {
  return (
    <main className="com_container com_training p_video_evaluation_register">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu6_4">
            화상 평가<span className="bar"></span>
            <span className="point_txt">화상시강 평가표 등록</span>
          </h2>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <div className="board_wrap_row">
              <section className="board_wrap">
                <table className="com_board_list type_row">
                  <colgroup>
                    <col width="150" />
                    <col width="auto" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th>평가자 명</th>
                      <td>김교사103</td>
                    </tr>
                    <tr>
                      <th>과목</th>
                      <td>수학</td>
                    </tr>
                    <tr>
                      <th>교육기수</th>
                      <td>16기</td>
                    </tr>
                    <tr>
                      <th>평가일자</th>
                      <td>
                        <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </section>
              <section className="board_wrap">
                <table className="com_board_list type_row">
                  <colgroup>
                    <col width="220" />
                    <col width="auto" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th>면접점수 ㅣ 시강점수 ㅣ 시강등급</th>
                      <td>78 ㅣ 45 ㅣ -c</td>
                    </tr>
                    <tr>
                      <th className="adj_h">
                        사전점검
                        <p className="sub">(펜 미사용시 재시강 요청)</p>
                      </th>
                      <td className="adj_h">
                        <div className="check">
                          <input type="radio" name="rdo" id="rdo_01" className="com_chk circle" />
                          <label htmlFor="rdo_01">펜사용</label>
                          <input type="radio" name="rdo" id="rdo_02" className="com_chk circle" />
                          <label htmlFor="rdo_02">펜 미사용</label>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>수업 환경 체크</th>
                      <td>
                        <div className="check">
                          <input type="radio" name="rdo2" id="rdo01" className="com_chk circle" />
                          <label htmlFor="rdo01">컴퓨터</label>
                          <input type="radio" name="rdo2" id="rdo02" className="com_chk circle" />
                          <label htmlFor="rdo02">노트북</label>
                          <input type="radio" name="rdo2" id="rdo03" className="com_chk circle" />
                          <label htmlFor="rdo03">태블릿</label>
                          <input type="radio" name="rdo2" id="rdo04" className="com_chk circle" />
                          <label htmlFor="rdo04">태블릿</label>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </section>
            </div>

            <table className="com_board_list type_score">
              <colgroup>
                <col width="150" />
                <col width="auto" />
                <col width="100" />
                <col width="100" />
                <col width="100" />
                <col width="100" />
                <col width="100" />
                <col width="100" />
              </colgroup>
              <thead>
                <tr>
                  <th>내용</th>
                  <th>문항</th>
                  <th>10</th>
                  <th>8</th>
                  <th>6</th>
                  <th>4</th>
                  <th>2</th>
                  <th>점수</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td rowSpan={3} className="bg_gray">
                    직관
                  </td>
                  <td className="td_left">정시에 수업을 개설하고 링크를 발송했습니까?</td>
                  <td>미리</td>
                  <td>정시</td>
                  <td>시간조정</td>
                  <td className="bg_col">
                    지각 <br />
                    사전통보
                  </td>
                  <td>무단지각</td>
                  <td className="com_blue_txt">10</td>
                </tr>
                <tr>
                  <td className="td_left">화면에 복장은 단정합니까?</td>
                  <td>매우단정</td>
                  <td>단정</td>
                  <td className="bg_col">보통</td>
                  <td>불량</td>
                  <td>매우불량</td>
                  <td className="com_blue_txt">10</td>
                </tr>
                <tr>
                  <td className="td_left">강사는 카메라, 마이크, 스피커, 듀얼모니터를 사용중입니까?</td>
                  <td>매우호감</td>
                  <td>호감</td>
                  <td>보통</td>
                  <td className="bg_col">
                    약간
                    <br />
                    비호감
                  </td>
                  <td>비호감</td>
                  <td className="com_blue_txt">10</td>
                </tr>
                <tr>
                  <td className="bg_gray">장비체크</td>
                  <td className="td_left">강사는 카메라, 마이크, 스피커, 듀얼모니터를 사용중입니까?</td>
                  <td>전부사용</td>
                  <td>3개사용</td>
                  <td>2개사용</td>
                  <td>1개사용</td>
                  <td className="bg_col">미사용</td>
                  <td className="com_blue_txt">10</td>
                </tr>
                <tr>
                  <td rowSpan={2} className="bg_gray">
                    Zoom 사용
                  </td>
                  <td className="td_left">강사는 화면 공유를 문제없이 사용합니까?</td>
                  <td className="bg_col">매우능숙</td>
                  <td>능숙</td>
                  <td>보통</td>
                  <td>미흡</td>
                  <td>매우미흡</td>
                  <td className="com_blue_txt">10</td>
                </tr>
                <tr>
                  <td className="td_left">강사는 화면 전환을 할 때 버벅임이 없습니까?</td>
                  <td>매우능숙</td>
                  <td>능숙</td>
                  <td className="bg_col">보통</td>
                  <td>미흡</td>
                  <td>매우미흡</td>
                  <td className="com_blue_txt">10</td>
                </tr>
                <tr>
                  <td rowSpan={4} className="bg_gray">
                    화상수업능력
                  </td>
                  <td className="td_left">(질문) 화상수업 지도 경력은 얼마나 되십니까?</td>
                  <td>3년 이상</td>
                  <td className="bg_col">2년 이상</td>
                  <td>1년 이상</td>
                  <td>1년 미만</td>
                  <td>없음</td>
                  <td className="com_blue_txt">10</td>
                </tr>
                <tr>
                  <td className="td_left">강사는 적절히 카메라를 보며 시선처리를 하고 있습니까?</td>
                  <td>매우능숙</td>
                  <td className="bg_col">능숙</td>
                  <td>보통</td>
                  <td>미흡</td>
                  <td>매우미흡</td>
                  <td className="com_blue_txt">10</td>
                </tr>
                <tr>
                  <td className="td_left">강사는 펜 사용(글씨체, 다양한 색 사용)에 불편함은 없습니까?</td>
                  <td>매우능숙</td>
                  <td>능숙</td>
                  <td>보통</td>
                  <td>미흡</td>
                  <td className="bg_col"> 매우미흡</td>
                  <td className="com_blue_txt">10</td>
                </tr>
                <tr>
                  <td className="td_left">돌발테스트에 대해 원활하게 대응합니까?</td>
                  <td>매우능숙</td>
                  <td className="bg_col">능숙</td>
                  <td>보통</td>
                  <td>미흡</td>
                  <td>매우미흡</td>
                  <td className="com_blue_txt">10</td>
                </tr>
                <tr>
                  <td colSpan={7}>
                    <strong>총점(70점 미만 재평가)</strong>
                  </td>
                  <td className="com_red_txt">68</td>
                </tr>
              </tbody>
            </table>
            <textarea name="" id="" className="textarea" placeholder="[평가의견] 인상 깊었던 점, 잘한 점과 미흡한 점, 보완되었으면 하는 내용 등 자유롭게 기재해주세요"></textarea>
            <div className="com_btn_wrap center bottom">
              <button className="com_btn orange s">등록</button>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
};

export default VideoEvaluationRegister;
